import {
  isServer,
  QueryClient,
  MutationCache,
  defaultShouldDehydrateQuery,
} from '@react/utils/queryHooks';

function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
      dehydrate: {
        shouldDehydrateQuery: (query) => {
          return (
            defaultShouldDehydrateQuery(query) ||
            query.state.status === 'pending'
          );
        },
      },
    },
    mutationCache: new MutationCache({
      onError: (_error, _variables, _context, mutation) => {
        if (!mutation.options?.meta?.manual) {
          // handle error
        }
      },
    }),
  });
}

let browserQueryClient: QueryClient | undefined = undefined;

export function getQueryClient() {
  if (isServer) {
    return createQueryClient();
  } else {
    if (!browserQueryClient) {
      browserQueryClient = createQueryClient();
    }

    return browserQueryClient;
  }
}
